import { render, staticRenderFns } from "./ConsultasListagem.vue?vue&type=template&id=518c3216"
import script from "./ConsultasListagem.vue?vue&type=script&lang=js"
export * from "./ConsultasListagem.vue?vue&type=script&lang=js"
import style0 from "./ConsultasListagem.vue?vue&type=style&index=0&id=518c3216&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports